import {Box, Stack, Typography} from "@mui/material";
import UserAvatar from "../UserAvatar/UserAvatar";
import TextWithIcon from "../TextWithIcon";
import {toLocalDate} from "../../utils/formatData";
import {FiCalendar, FiMail} from "react-icons/fi";
import {useTheme} from "@mui/material";

const UserInfo = ({user}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        borderRadius: theme.palette.card.borderRadius,
        border: `1px solid ${theme.palette.card.border}`,
        padding: 3,
        bgcolor: theme.palette.card.background,
        boxShadow: theme.palette.card.borderShadow
      }}
    >
      {/* Header: Avatar + Nombre */}
      <Stack direction="row" spacing={2} alignItems="center" mb={2}>
        <UserAvatar name={`${user?.name} ${user?.surname}`} size={60} />
        <Typography variant="h2" fontWeight="bold" color={theme.palette.text.primary}>
          {user?.name} {user?.surname}
        </Typography>
      </Stack>

      {/* Datos del usuario */}
      <Stack ml={1} spacing={1.5}>
        <TextWithIcon Icon={FiMail} text={user?.email} />
        {user?.ts_email && <TextWithIcon Icon={FiMail} text={`TS Email: ${user.ts_email}`} />}
        <TextWithIcon Icon={FiCalendar} text={toLocalDate(user?.created_at)} />
      </Stack>
    </Box>
  );
};

export default UserInfo;
